import(/* webpackMode: "eager" */ "/app/src/app/(modules)/docs/public/[key]/page.tsx");
